import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import _ from 'lodash'
import Modal from 'react-modal';
import { MdDelete } from 'react-icons/lib/md';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { MdDone, MdClose, MdCreate } from 'react-icons/lib/md';

import {
  fetch_lkp_DesignSource_AE, fetch_lkp_Discipline_AE, fetch_lkp_JobType_AE, fetch_lkp_Track_AE,
  fetch_lkp_ReviewStatus_AE, fetchTrackingMembers_AE, getAETrackingByProjectId,
  fetchTrackingPhase_AE, fetch_lkp_Phase_AE, fetch_lkp_StatusTracking_AE, fetch_lkp_ReviewPhaseStatus_AE
} from '../../actions/additional_actions';

import { fetchPermissionsByModule } from '../../actions/project_actions';
import { DateField } from './schedule_utils';
import { withAuth } from '../../actions/';
import { modalStyle } from '../../constants';
import TeamMemberFormAE from './TeamMemberFormAE';
import TeamMemberSearchAE from './TeamMemberSearchAE';
import { getDateValue } from '../../utils/date';
import AETrackingViewOnly from './AETrackingViewOnly';
import { DateFieldFixedDateBelow } from './date_picker_fixed_dateBelow';
import { queueTypes } from '../../utils';

class AETracking extends Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   permissionsModule: PropTypes.object.isRequired,
  // }

  constructor(props) {
    super(props);

    this.state = {
      aeTrack: {},
      aeTrackBottomPartfArray: [],
      toEdit: null, // member
      showSavedMsg: false,
      showWarningMsg: false,
      modalIsOpen: false,
      modalIsOpenPhase: false,
      modalCommentsVisible: false,
      commentInModal: '',
      aeRequiredAttributes: this.getRequiredAttr(),
      designMembers: [],
      showEmailSuccess: false,
      showEmailError: false,

      isLoading: false,
      isLoadingMain: false,
      canEditComments: false,
      modalIsOpenComment: false,
      commentInModelId: '',
      canEditAETrack: false,
      showAETrackEdit: false,
      editAeTrackId: null,
      deleteAeTrackId: null,
      isAccepted: null,
      copyAeTrack: null
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChangeBottom = this.handleDateChangeBottom.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSelectChangeReviewStatus = this.handleSelectChangeReviewStatus.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleIntakeChange = this.handleIntakeChange.bind(this);
    this.handleEmailCheckboxChange = this.handleEmailCheckboxChange.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);

    this.renderModal = this.renderModal.bind(this);
    this.confirmSubmit = this.confirmSubmit.bind(this);
    this.confirmSubmitPhase = this.confirmSubmitPhase.bind(this);
    this.addMember = this.addMember.bind(this);
    this.saveMember = this.saveMember.bind(this);
    this.deleteMember = this.deleteMember.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalPhase = this.closeModalPhase.bind(this);

    this.submitMainTrack = this.submitMainTrack.bind(this);
    this.putTrackingPhase = this.putTrackingPhase.bind(this);
    this.submitTrackingPhase = this.submitTrackingPhase.bind(this);
    this.showCommentsModal = this.showCommentsModal.bind(this);
    this.validateAEtop = this.validateAEtop.bind(this);
    this.onDocDownload = this.onDocDownload.bind(this);
    this.sendTeamEmail = this.sendTeamEmail.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.submitTrackingPhaseComment = this.submitTrackingPhaseComment.bind(this);
    this.closeModalComment = this.closeModalComment.bind(this);

    this.showAETrackEditComfirmationModal = this.showAETrackEditComfirmationModal.bind(this);
    this.renderConfirmModalAETrack = this.renderConfirmModalAETrack.bind(this);
    this.closeAeTrackComfirmModal = this.closeAeTrackComfirmModal.bind(this);
  }

  getRequiredAttr() {
    return {
      jobTypeId: '',
      disciplineId: '',
      designSourceId: '',
      trackId: '',
      strategyBoardDate: '',
      leaderOrMember: '',
    }
  }

  UNSAFE_componentWillMount() {
    const { projectId, designSources_AE, disciplines_AE, jobTypes_AE, tracks_AE, reviewStatuses_AE, phases_AE,
      trackingPhases_AE, statusTracking_AE, trackingMembers_AE, reviewPhaseStatuses_AE } = this.props;

    this.props.fetchPermissionsByModule(this.props.projectId);
    this.props.getAETrackingByProjectId(projectId);
    this.props.fetchTrackingMembers_AE(projectId);
    this.props.fetchTrackingPhase_AE(projectId);

    this.setState({ aeTrack: this.props.aeTracksMain[0] });
    this.setState({ aeTrackBottomPartArray: trackingPhases_AE });
    this.setState({ designMembers: trackingMembers_AE });

    if (designSources_AE.length === 0) this.props.fetch_lkp_DesignSource_AE();
    if (disciplines_AE.length === 0) this.props.fetch_lkp_Discipline_AE();
    if (jobTypes_AE.length === 0) this.props.fetch_lkp_JobType_AE();
    if (tracks_AE.length === 0) this.props.fetch_lkp_Track_AE();
    if (reviewStatuses_AE.length === 0) this.props.fetch_lkp_ReviewStatus_AE();
    if (reviewPhaseStatuses_AE.length === 0) this.props.fetch_lkp_ReviewPhaseStatus_AE(projectId);
    if (phases_AE.length === 0) this.props.fetch_lkp_Phase_AE();
    if (statusTracking_AE) this.props.fetch_lkp_StatusTracking_AE();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.aeTracksMain[0] !== nextProps.aeTracksMain[0]) {
      this.setState({ aeTrack: nextProps.aeTracksMain[0] })

      let x = nextProps.aeTracksMain[0].trackingPhase_AE;
      this.setState({ copyAeTrack: x[x.length - 1] });
    }
    if (nextProps.trackingPhases_AE.length > 0)
      this.setState({ aeTrackBottomPartArray: nextProps.trackingPhases_AE })

    if (nextProps.trackingMembers_AE.length > 0)
      this.setState({ designMembers: nextProps.trackingMembers_AE })
  }

  getSelectOptions(values, name) {
    return this.props[values].map(value => {
      return {
        label: value[name],
        value: value.id
      }
    });
  }

  getSelectOptionsReviewStatus(values, name) {
    // exclude some status options
    var reviewStatuses = _.filter(this.props[values], function (v) { return v.id !== 5 && v.id !== 6 && v.id !== 7 });

    return reviewStatuses.map(value => {
      return {
        label: value[name],
        value: value.id
      }
    });
  }

  getSelectLabels(id, values, name) {
    if (id !== undefined) {
      let label = _.find(this.props[values], function (s) { return s.id === id });
      if (label)
        return label[name];
    }
    else return null;
  }

  getReviewStatusName(reviewStatusId) {
    let label = _.find(this.props.reviewStatuses_AE, function (s) { return s.id === reviewStatusId });
    if (label)
      return label.reviewStatus;
    else return null;
  }

  getStatusTracking(statusTrackingId) {
    let label = _.find(this.props.statusTracking_AE, function (s) { return s.id === statusTrackingId });
    if (label)
      return label.status;
    else return null;
  }

  handleSelectChange(field) {
    return (option) => {
      const value = option ? option.value : null;
      const aeTrack = { ...this.state.aeTrack, [field]: value }
      this.setState({ aeTrack });
    }
  }

  handleSelectChangeReviewStatus(field, index, reviewStatusId = null) {
    return (option) => {
      const value = option ? option.value : null;
      const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
      aeTrackBottomPartArray[index][field] = value;
      this.setState({ deleteAeTrackId: reviewStatusId });
      this.setState({ aeTrackBottomPartArray });
    }
  }

  handleCheckboxChange(name) {
    return (e) => {
      const aeTrack = this.state.aeTrack;
      if (aeTrack[name] === true)
        aeTrack[name] = false;
      else
        aeTrack[name] = true;
      this.setState({ aeTrack });
    }
  }

  handleEmailCheckboxChange(attribute, index) {
    return (e) => {
      const designMembers = this.state.designMembers;

      if (designMembers[index][attribute] === true)
        designMembers[index][attribute] = false;
      else
        designMembers[index][attribute] = true;

      this.setState({ designMembers });
    }
  }

  handleIntakeChange(field, index) {
    return (e) => {
      const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
      if (e.target.value === 'false') {
        aeTrackBottomPartArray[index][field] = false;
        aeTrackBottomPartArray[index]['aeAcceptedDate'] = null;
        aeTrackBottomPartArray[index]['aeTargetDate'] = null;
        aeTrackBottomPartArray[index]['dateRemaining'] = null;
        aeTrackBottomPartArray[index]['aeActualReviewedDate'] = null;
        aeTrackBottomPartArray[index]['reviewStatusId'] = null;
        this.setState({ isAccepted: false });
      }
      else {
        aeTrackBottomPartArray[index][field] = true;
        aeTrackBottomPartArray[index]['aeRejectedDate'] = null;
        this.setState({ isAccepted: true });
      }
      this.setState({ aeTrackBottomPartArray });
    }
  }

  handleDateChange(name) {
    return (date) => {
      const aeTrack = this.state.aeTrack;
      aeTrack[name] = date;
      this.setState({ aeTrack });
    }
  }

  handleDateChangeBottom(name, index) {
    return (date) => {
      const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
      aeTrackBottomPartArray[index][name] = date;
      this.setState({ aeTrackBottomPartArray });

      var a = new Date(aeTrackBottomPartArray[index].aeAcceptedDate);//existing - get entered aeAcceptedDate
      a.setDate(a.getDate());
      var accepted = moment(a);
      var lowerLimitDate = new Date(aeTrackBottomPartArray[index].pmSubmittedActualDate);
      var lowerLimit = moment(lowerLimitDate, 'MM/DD/YYYY').startOf('day')//get lowerLimit
      var higherLimit = moment().startOf('day'); //get higher limit
      var acceptedCheck = moment(a, 'MM/DD/YYYY').startOf('day');//to parse the correct format created a new acceptedCheck variable

      if (!acceptedCheck.isBetween(lowerLimit, higherLimit, 'day', '[]')) { //check if entered aeAcceptedDate is within the limits
        aeTrackBottomPartArray[index].aeAcceptedDate = '';
        this.setState({ aeTrackBottomPartArray })
      }

      var b = new Date(aeTrackBottomPartArray[index].aeActualReviewedDate);
      b.setDate(b.getDate());
      var reviwed = moment(b);

      if (reviwed.isBefore(accepted, 'day')) {
        aeTrackBottomPartArray[index].aeActualReviewedDate = '';
        this.setState({ aeTrackBottomPartArray });
      }

      if (name === 'aeAcceptedDate')
        this.calculateAeTargetDate('aeTargetDate', index, date);
    }
  }

  getCurrentDate() {
    //  var today = moment();
    //  var tomorrow = moment(today, "DD-MM-YYYY").add(1, 'days');
    var today = moment().endOf('day');
    return today;
  }

  getPrev10Days() {
    var today = moment();
    var prev10days = moment(today, 'DD-MM-YYYY').subtract(9, 'days');
    return prev10days;
  }

  calculateAeTargetDate(name, index, date) {
    var datePlus21 = new Date(date);
    datePlus21.setDate(datePlus21.getDate() + 21);

    var dd = datePlus21.getDate();
    var mm = datePlus21.getMonth() + 1;
    var y = datePlus21.getFullYear();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
    aeTrackBottomPartArray[index][name] = mm + '/' + dd + '/' + y;
  }

  calcDaysRemaining(row) {
    // new logic: actual reviewed date - accepted date
    var daysLeft = null;

    if (row.aeActualReviewedDate && row.aeAcceptedDate) {
      var tgDate = new Date(row.aeActualReviewedDate);
      var tgDateMoment = moment(tgDate);

      var aeAccDate = new Date(row.aeAcceptedDate);
      var aeAccDateMoment = moment(aeAccDate);

      daysLeft = tgDateMoment.diff(aeAccDateMoment, 'days');
    }
    return daysLeft;
  }

  handleChange(field, index) {
    return (e) => {
      const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
      aeTrackBottomPartArray[index][field] = e.target.value;
      this.setState({ aeTrackBottomPartArray });
    };
  }

  handleChangeInput(field) {
    return (e) => {
      const aeTrack = this.state.aeTrack;
      aeTrack[field] = e.target.value;
      this.setState({ aeTrack });
    };
  }

  addMember(user, isLeader) {
    if (isLeader) {
      user.isTeamLeader = true;
    }
    else
      user.isTeamLeader = false;
    this.setState({ toEdit: user });
  }

  deleteMember(memberId) {
    const projectId = this.props.projectId;

    const url = `/projects/${projectId}/DeleteMember_AE/${memberId}`;
    withAuth(
      { method: 'delete', url },
      () => {
        this.props.fetchTrackingMembers_AE(projectId);
      },
      this.errorHandler
    );
  }

  closeModal() {
    this.setState({
      toEdit: null,
      modalIsOpen: false,
      modalCommentsVisible: false,
      canEditComments: false,
    });
  }

  closeModalPhase() {
    this.setState({ modalIsOpenPhase: false, });
  }

  saveMember(teamObj) {
    const { projectId } = this.props;

    let method = 'post';
    let url = `projects/${projectId}/TrackingMembers_AE`;

    return this.postMember(teamObj, method, url);
  }

  postMember(teamObj, method, url) {
    const { projectId } = this.props;
    const member_AE_Id = teamObj.member_AE_Id;
    const isTeamLeader = teamObj.isTeamLeader;
    const mainTrackingId = this.state.aeTrack.id;
    const phaseId = this.state.aeTrack.currentPhaseId;

    const data = { projectId, isTeamLeader, member_AE_Id, mainTrackingId, phaseId }

    withAuth(
      { method, url, data },
      () => {
        this.props.fetchTrackingMembers_AE(projectId);
        this.closeModal();
        this.callEmailTeam(projectId, data);
      },
      this.errorHandler
    )
  }

  callEmailTeam(projectId, data) {
    let method = 'post';
    let url = `projects/${projectId}/EmailTeamSeparated_AE`;

    withAuth(
      { method, url, data },
    )
  }

  submitMainTrack() {
    const { projectId } = this.props;
    const { aeTrack } = this.state;
    const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;

    if (aeTrackBottomPartArray.length === 0) { // if no records in trackingPhase -> create 1st
      this.setState({ isLoadingMain: true });

      var firstPhase = {
        mainTrackingId: aeTrack.id,
        phaseId: aeTrack.currentPhaseId,
        pMSubmittedActualDate: aeTrack.pmRequestSubmittedDate,
        projectId: projectId,
        comments: '',
        intakeAccepted: 1
      }
      this.putAeTrack(aeTrack, true);
      this.postTrackingPhase(firstPhase); // 1st post to trackingPhase
    }

    else if (aeTrackBottomPartArray.length > 0) {
      var lastItem = aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1];

      // if they changed track && last phase is not Objectives
      if ((aeTrack.trackId !== lastItem.lkp_Phase_AE.trackingId) && (lastItem.lkp_Phase_AE.trackingId !== 4) && aeTrack.queueTypeId !== 1) {
        this.setState({ isLoadingMain: true });

        aeTrack.currentPhaseId = 19; // projectobjectives phase
        this.putAeTrack(aeTrack, true);

        var nextPhase = {
          mainTrackingId: aeTrack.id,
          phaseId: aeTrack.currentPhaseId,
          pMSubmittedActualDate: aeTrack.pmRequestSubmittedDate,
          projectId: projectId,
        }
        this.postTrackingPhase(nextPhase);
      }
      // if (last phase is Objectives) or (last phase is not Objectives and they did not change the tract) -> account for user mistake
      else if ((lastItem.lkp_Phase_AE.trackingId === 4) || (lastItem.lkp_Phase_AE.trackingId !== 4 && aeTrack.trackId === lastItem.lkp_Phase_AE.trackingId)) {
        this.putAeTrack(aeTrack, true);
      }
      else {
        this.setState({ showWarningMsg: true });
        toast.warning('Wait for Project Manager submission');
      }
    }
  }

  putAeTrack(aeTrack, msg) {
    let method = 'put';
    let url = `projects/${aeTrack.projectId}/AETracking/${aeTrack.id}`;

    withAuth(
      { method, url, data: aeTrack },
      () => {
        this.closeModal();
        this.props.getAETrackingByProjectId(aeTrack.projectId);
        if (msg) {
          this.setState({ showSavedMsg: true });
          toast.success('Saved Successfully!');
        }
      },
      this.errorHandler
    )
  }

  postTrackingPhase(phase) {
    phase.intakeAccepted = null;

    let method = 'post';
    let url = `projects/${phase.projectId}/AETrackingPhase`;

    withAuth(
      { method, url, data: phase },
      () => {
        this.props.fetchTrackingPhase_AE(phase.projectId);
        this.props.fetch_lkp_ReviewPhaseStatus_AE(phase.projectId);
        this.setState({ isLoadingMain: false });
      },
      this.errorHandler
    )
  }

  //add next row when reviewStatusId changes on EDIT btn click
  //Only when reviewStatusId changes from 1 --> 3 or 1 --> 4 or 2 --> 3  or 2 --> 4 and Vice Versa
  addBottomRow(newPhase, aeTrackNew, prevPhaseData) {
    const { projectId } = this.props;
    const { aeTrack } = this.state;

    if (newPhase) {
      var newPhase = {
        mainTrackingId: aeTrack.id,
        phaseId: prevPhaseData,
        projectId: projectId,
      }
      aeTrackNew.currentPhaseId = prevPhaseData;

    } else {

      var newPhase = {
        mainTrackingId: aeTrack.id,
        phaseId: this.getNextPhaseName(aeTrack, true),
        projectId: projectId,
      }
      aeTrackNew.currentPhaseId = newPhase.phaseId;
    }

    this.putAeTrack(aeTrackNew);
    this.postTrackingPhase(newPhase);
  }
  putTrackingPhase(phase) {
    let method = 'put';
    let url = `projects/${phase.projectId}/AETrackingPhase/${phase.id}`;

    if (this.state.editAeTrackId != null) {
      this.setState({ editAeTrackId: null });

      let currentPhase = phase.reviewStatusId;
      let prevPhase = this.state.deleteAeTrackId;

      //delete last row based on reviewStatusId change
      if ((prevPhase == 1 || prevPhase == 2) && (currentPhase == 4 || currentPhase == 3) || (prevPhase == 3 || prevPhase == 4) && (currentPhase == 1 || currentPhase == 2)) {

        let prevPhaseData = this.state.aeTrackBottomPartArray[this.state.aeTrackBottomPartArray.length - 2];
        let lastPhase = this.state.aeTrackBottomPartArray[this.state.aeTrackBottomPartArray.length - 1];
        lastPhase.isActive = false;

        let url = `projects/${phase.projectId}/AETrackingPhase/${lastPhase.id}`;
        let aeTrackNew = this.state.aeTrack;
        // aeTrackNew.currentPhaseId = prevPhaseData.phaseId;
        aeTrackNew.queueTypeId = 1;

        if ((prevPhase == 1 || prevPhase == 2) && (currentPhase == 4 || currentPhase == 3)) {
          //if statusTrackingId ==3 means it has to be changed to 1 to make Request Status Active
          if (aeTrackNew.statusTrackingId == 3) {
            aeTrackNew.statusTrackingId = 1;
            lastPhase.isActive = true
            this.addBottomRow(true, aeTrackNew, lastPhase.phaseId);
          }
          else { this.addBottomRow(true, aeTrackNew, prevPhaseData.phaseId); }
        }
        else if ((prevPhase == 3 || prevPhase == 4) && (currentPhase == 1 || currentPhase == 2)) {
          if (aeTrackNew.currentPhaseId != 16 && aeTrackNew.currentPhaseId != 17 && aeTrackNew.currentPhaseId != 18) {
            this.addBottomRow(false, aeTrackNew, prevPhaseData.phaseId);
          }
          else {
            aeTrackNew.statusTrackingId = 3;
            aeTrackNew.currentPhaseId = null;
            this.putAeTrack(aeTrackNew);
          }
        }

        withAuth(
          { method, url, data: lastPhase },
          () => {
            this.props.fetchTrackingPhase_AE(lastPhase.projectId);
          },
          this.errorHandler
        )
      }
    }
    withAuth(
      { method, url, data: phase },
      () => {
        this.closeModalPhase();
        this.props.fetchTrackingPhase_AE(phase.projectId);
        this.setState({ showSavedMsg: true });
        toast.success('Saved Successfully!');
        this.setState({ isLoading: false });
      },
      this.errorHandler
    )
  }

  submitTrackingPhase(row) {
    const { aeTrack } = this.state;

    var rowToInsert = {};
    rowToInsert.id = '';
    rowToInsert.reviewStatusId = '';
    rowToInsert.mainTrackingId = row.mainTrackingId;
    rowToInsert.projectId = row.projectId;

    // submit
    if ((row.reviewStatusId !== '' && row.reviewStatusId !== null) || !row.intakeAccepted) {
      // 1st phase: Objectives
      if (row.phaseId === 19) {
        this.setState({ isLoadingMain: true });
        if (aeTrack.isPreSchematic) //2nd phase: Pre-schematic
        {
          switch (aeTrack.trackId) {
            case 1:
              rowToInsert.phaseId = 27;
              break;
            case 2:
              rowToInsert.phaseId = 28;
              break;
            case 3:
              rowToInsert.phaseId = 29;
              break;
            default:
              break;
          }
        }
        else if (!aeTrack.isPreSchematic) // 2nd phase: NOT Pre-schematic
        {
          switch (aeTrack.trackId) {
            case 1:
              rowToInsert.phaseId = 7;
              break;
            case 2:
              rowToInsert.phaseId = 8;
              break;
            case 3:
              rowToInsert.phaseId = 15;
              break;
            default:
              break;
          }
        }
        // review status is not accepted or intake is rejected
        // TODO: no matter review status for the PO phase ?
        if (!row.intakeAccepted)
          rowToInsert.phaseId = row.phaseId;  // add same phase

        this.postTrackingPhase(rowToInsert);
      }

      else if (row.phaseId !== 19) { // anything other than 1st phase
        this.setState({ isLoadingMain: true });

        var tracksArray = []; var sequenceNumber = 0; var phaseForRow = {};

        // all phases for this track
        tracksArray = _.filter(this.props.phases_AE, function (o) { return o.trackingId === row.lkp_Phase_AE.trackingId; });
        sequenceNumber = row.lkp_Phase_AE.sequence;
        sequenceNumber++;
        phaseForRow = _.filter(tracksArray, function (n) { return n.sequence === sequenceNumber });

        if (phaseForRow.length > 0) { // if there are more phases left
          if (row.reviewStatusId !== 1 && row.reviewStatusId !== 2) // review status is anything but accepted
            rowToInsert.phaseId = row.phaseId;  // add same phase    
          else
            rowToInsert.phaseId = phaseForRow[0].id;

          this.postTrackingPhase(rowToInsert);
        }

        else { // if last phase
          if (row.reviewStatusId !== 1 && row.reviewStatusId !== 2) { // review status is anything but accepted
            rowToInsert.phaseId = row.phaseId; // add same phase 
            this.postTrackingPhase(rowToInsert);
          }
        }
      }
      this.setState({ isLoading: true });
      aeTrack.currentPhaseId = rowToInsert.phaseId;
      aeTrack.queueTypeId = 1; // send to PM queue

      if (row.aeAcceptedDate !== null && row.aeAcceptedDate !== '')
        row.intakeAccepted = 1;
      else
        row.intakeAccepted = 0;

      this.putTrackingPhase(row); // send test email to Program dir
      this.putAeTrack(aeTrack, false);
    }
    // reviewStatus is empty and intake is accepted -> save
    else if ((row.reviewStatusId === '' || row.reviewStatusId === null) && row.intakeAccepted) {

      // disable intake and accepted date
      const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
      aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1].intakeDisabled = true;
      this.setState({ aeTrackBottomPartArray });

      this.putTrackingPhase(row);
    }
    this.setState({ copyAeTrack: { ...row, intakeAccepted: true } });
  }

  renderEditForm(toEdit) {
    return (
      <div className="member-form modal-form">
        <h1>Add</h1>
        <TeamMemberFormAE
          teamObj={toEdit} onSave={this.saveMember} />

        <div className="modal-close"
          onClick={() => this.closeModal()}>
          <span className="close"></span>
        </div>
      </div>
    )
  }

  renderModal() {
    const { toEdit } = this.state;

    let Content = null;
    if (toEdit) Content = this.renderEditForm(toEdit);

    return (
      <Modal
        isOpen={!!Content}
        style={modalStyle}
        contentLabel="Add"
      >
        {Content}
      </Modal>
    )
  }

  renderConfirmModal() {
    const { isLoadingMain } = this.state;

    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        style={modalStyle}
        contentLabel="Confirm"
      >
        <div className="alert-modal">
          <h1>Confirm</h1>
          <div className="modal-close"
            onClick={() => this.closeModal()}>
            <span className="close"></span>
          </div>
          <p>Are you sure you want to save with the entered options?</p>
          <div className="actions">
            <button className="alert-save" onClick={this.submitMainTrack} disabled={isLoadingMain}>Yes</button>
            <button className="alert-cancel" onClick={() => this.closeModal()}>No</button>
            {isLoadingMain ? <div className="loader loader-infra" /> : null}
          </div>
        </div>
      </Modal>
    )
  }

  handleCommentChange() {
    var someProperty = { ...this.state.aeTrack };
    someProperty.comment = this.state.commentInModal;
    this.setState({ aeTrack: someProperty })
    this.setState({ modalIsOpenComment: true });
    this.closeModal();
  }

  closeModalComment() {
    this.setState({ canEditComments: false });
    this.setState({ modalIsOpenComment: false });
  }

  submitTrackingPhaseComment(data) {
    this.closeModalComment();
    let method = 'put';
    let url = `projects/${this.state.aeTrack.projectId}/PutAETrackingsComment/${this.state.commentInModelId}`;

    withAuth(
      { method, url, data: this.state.commentInModal },
      () => {
        //this.closeModalPhase();
        //this.props.fetchTrackingPhase_AE(phase.projectId);
        this.setState({ showSavedMsg: true });
        toast.success('Saved Successfully!');
        this.setState({ isLoading: false });
        this.props.fetchTrackingPhase_AE(this.state.aeTrack.projectId);
      },
      this.errorHandler
    )

  }

  renderConfirmModalComment() {
    const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
    var lastItem = aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1];

    const { isLoading } = this.state;

    return (
      <Modal
        isOpen={this.state.modalIsOpenComment}
        style={modalStyle}
        contentLabel="Confirm"
      >
        <div className="alert-modal">
          <h1>Confirm</h1>
          <div className="modal-close"
            onClick={() => this.closeModalComment()}>
            <span className="close"></span>
          </div>
          <p>Are you sure you want to save comment?</p>
          <div className="actions">
            <button className="alert-save" onClick={() => this.submitTrackingPhaseComment(lastItem)} disabled={isLoading}>Yes</button>
            <button className="alert-cancel" onClick={() => this.closeModalComment()}>No</button>
            {isLoading ? <div className="loader loader-infra" /> : null}
          </div>
        </div>
      </Modal>
    )
  }

  renderCommentsModal() {
    return (
      <Modal
        isOpen={this.state.modalCommentsVisible}
        style={modalStyle}
        contentLabel="Comments"
      >
        <div className="alert-modal">
          <h1>Comments
            {this.props.permissionsModule.isDesignDir && <button onClick={() => this.setState(prevState => ({
              canEditComments: !prevState.canEditComments
            }))}>
              <span><MdCreate size={22} color='#8492a6' /></span>
            </button>}
          </h1>
          <div className="modal-close"
            onClick={() => this.closeModal()}>
            <span className="close"></span>
          </div>
          {!this.state.canEditComments && <p>{this.state.commentInModal}</p>}
          {this.state.canEditComments && (<textarea name="editComment" rows='6' cols='60' value={this.state.commentInModal}
            onChange={(e) => { this.setState({ commentInModal: e.target.value }); }} />)}
          {this.state.canEditComments && <button className="btn-save float-left margin-left-0 margin-top-1" onClick={this.handleCommentChange}>Save</button>}
        </div>
      </Modal>
    )
  }

  renderConfirmModalPhase() {
    const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
    var lastItem = aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1];

    const { isLoading } = this.state;

    return (
      <Modal
        isOpen={this.state.modalIsOpenPhase}
        style={modalStyle}
        contentLabel="Confirm"
      >
        <div className="alert-modal">
          <h1>Confirm</h1>
          <div className="modal-close"
            onClick={() => this.closeModalPhase()}>
            <span className="close"></span>
          </div>
          <p>Are you sure you want to save with the entered options?</p>
          <div className="actions">
            <button className="alert-save" onClick={() => this.submitTrackingPhase(lastItem)} disabled={isLoading}>Yes</button>
            <button className="alert-cancel" onClick={() => this.closeModalPhase()}>No</button>
            {isLoading ? <div className="loader loader-infra" /> : null}
          </div>
        </div>
      </Modal>
    )
  }

  validateAEtop() {
    const { aeTrack, aeRequiredAttributes } = this.state;

    if (aeTrack) {
      if (!_.isEmpty(aeTrack) && (aeTrack.hasOwnProperty('id'))) {

        for (var attr in aeRequiredAttributes) {
          if ((aeTrack[attr] === null || aeTrack[attr] === '' || aeTrack[attr] === undefined) || (attr === 'trackId' && aeTrack[attr] === 4)) {

            if (attr === 'strategyBoardDate')
              aeRequiredAttributes[attr] = 'validateDate';
            else
              aeRequiredAttributes[attr] = 'validate-select';
          }

          else
            aeRequiredAttributes[attr] = '';
        }

        if (this.props.trackingMembers_AE.length <= 1)
          aeRequiredAttributes['leaderOrMember'] = 'validate-input-search';
        else
          aeRequiredAttributes['leaderOrMember'] = '';

        this.setState({ aeRequiredAttributes });

        let aeAttrToArray = Object.values(aeRequiredAttributes);
        let isValid = aeAttrToArray.some(prop => prop === 'validate-select' || prop === 'validateDate' || prop === 'validate-input-search') === false;

        if (isValid)
          this.confirmSubmit();
      }
    }
  }

  confirmSubmit() {
    this.setState({ modalIsOpen: true });
  }

  confirmSubmitPhase() {
    this.setState({ modalIsOpenPhase: true });
  }

  showCommentsModal(row) {
    this.setState({ modalCommentsVisible: true, commentInModal: row.comments, commentInModelId: row.id });
  }

  sendTeamEmail() {
    const projectId = this.props.projectId;
    const designMembers = this.state.designMembers;
    var selectedMembers = _.filter(designMembers, function (n) { return n.isEmailChecked });

    let method = 'post';
    let url = `projects/${projectId}/EmailTeamMembers_AE`;

    withAuth(
      { method, url, data: selectedMembers },
      () => {
        this.props.fetchTrackingMembers_AE(projectId);
        this.setState({ showEmailSuccess: true });
        toast.success('Email was sent!');
      },
      this.errorHandler
    )
  }

  errorHandler(error) {
    this.setState({ isLoadingMain: false });
    this.setState({ isLoading: false });
    this.setState({ showEmailError: true });
    toast.error('Error has occured. Please try again.');
  }

  onDocDownload(doc) {
    const { projectId, blobUrl } = doc;
    const sasEndpoint = `projects/${projectId}/documents/sas`;

    return (e) => {
      e.preventDefault();

      withAuth(
        { method: 'get', url: sasEndpoint },
        (result) => this.startDocDownload(result, blobUrl),
        // this.notifyError
      );
    }
  }

  startDocDownload(result, blobUrl) {
    this.downloadLink.href = blobUrl + result.data.signature;
    this.downloadLink.click();
  }

  renderRowButtons(member) {
    let canEdit = true;

    if (canEdit) {
      return (
        <td>
          <button onClick={() => this.deleteMember(member.id)}>
            <span><MdDelete size={22} color='#8492a6' /></span>
          </button>
        </td>
      )
    }
  }

  renderCheckbox(member, index) {
    return (
      <td>
        <div className="md-checkbox">
          <input id={'emailChkbox' + index}
            type="checkbox"
            onChange={this.handleEmailCheckboxChange('isEmailChecked', index)}
            checked={member.isEmailChecked} />
          <label htmlFor={'emailChkbox' + index}></label>
        </div>
      </td>
    )
  }

  renderTable() {
    const { aeTrack } = this.state;
    const designMembers = this.state.designMembers;
    let canEmail = false;

    if (designMembers.some(m => m.isEmailChecked))
      canEmail = true;

    return (
      <div>
        <div className="col s12">
          <div className="table">
            <table className="td-table-border th-table-border table-striped">
              <thead>
                <tr>
                  <th>Role</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Studio</th>
                  <th>Discipline</th>
                  <th>Added Date</th>
                  <th>Email Sent Date</th>
                  {this.props.permissionsModule.isDesignDir && <th>Email</th>}
                  {this.props.permissionsModule.isDesignDir && <th>Delete</th>}
                </tr>
              </thead>
              <tbody>
                {designMembers.map((member, index) =>
                  <tr key={member.id}>
                    <td>{member.isTeamLeader ? 'Team leader' : 'Team member'}</td>
                    <td>{member.members_AE.employee.firstName}</td>
                    <td>{member.members_AE.employee.lastName}</td>
                    <td>{member.members_AE.studio_Members_AE.length > 0 && member.members_AE.studio_Members_AE[0].lkp_Studio_AE.studio}</td>
                    <td>{member.members_AE.lkp_Members_Discipline_AE && member.members_AE.lkp_Members_Discipline_AE.memberDiscipline}</td>
                    <td>{getDateValue(member.createdDate)}</td>
                    <td>{getDateValue(member.lastDateEmailSent)}</td>
                    {this.props.permissionsModule.isDesignDir ? this.renderCheckbox(member, index)
                      : <span></span>}
                    {this.props.permissionsModule.isDesignDir ? this.renderRowButtons(member)
                      : <span></span>}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {aeTrack &&
          <div className="col s12">
            <button className="btn-save float-right margin-top-1" onClick={this.sendTeamEmail} disabled={!canEmail}>Send</button>
          </div>}
      </div>
    );
  }

  getPhaseName(aeTrack) {
    let currentPhase = _.find(this.props.phases_AE, function (o) { return o.id === aeTrack.currentPhaseId; });
    if (currentPhase)
      return currentPhase.phaseName;
    else return null;
  }

  getNextPhaseName(aeTrack, getId = false) {
    var tracksArr = []; var sequenceNum = 0; var phaseFor = {};
    var currentPhase = _.find(this.props.phases_AE, function (o) { return o.id === aeTrack.currentPhaseId; });

    if (currentPhase && currentPhase.id !== 19) {
      tracksArr = _.filter(this.props.phases_AE, function (o) { return o.trackingId === currentPhase.trackingId; });
      sequenceNum = currentPhase.sequence;
      sequenceNum++;

      phaseFor = _.filter(tracksArr, function (n) { return n.sequence === sequenceNum });
    }

    // 1st phase
    else if (currentPhase && currentPhase.id === 19) {
      if (aeTrack.isPreSchematic)
        sequenceNum = 2;
      else
        sequenceNum = 3;
      phaseFor = _.filter(this.props.phases_AE, function (o) { return o.trackingId === aeTrack.trackId && o.sequence === sequenceNum });
    }

    if (phaseFor.length > 0 && getId) return phaseFor[0].id
    else if (phaseFor.length > 0)
      return phaseFor[0].phaseName;
    else return null;
  }



  showAETrackEditComfirmationModal(e) {
    this.setState({ showAETrackEdit: true });
    this.setState({ editAeTrackId: e });
  }
  closeAeTrackComfirmModal() {
    this.setState({ showAETrackEdit: false });
    //this.setState({ editAeTrackId: null });

  }

  getQueueName(queueTypeId) {
    return queueTypes[queueTypeId];
  }

  renderConfirmModalAETrack() {
    const { isLoading } = this.state;
    return (
      <Modal
        isOpen={this.state.showAETrackEdit}
        style={modalStyle}
        contentLabel="Confirm"
      >
        <div className="alert-modal">
          <h1>Confirm</h1>
          <div className="modal-close"
            onClick={() => {
              this.setState({ editAeTrackId: null });
              this.closeAeTrackComfirmModal()
            }
            }>
            <span className="close"></span>
          </div>
          <p>Are you sure you want to edit AETrack?</p>
          <div className="actions">
            <button className="alert-save" disabled={isLoading} onClick={() => {
              this.closeAeTrackComfirmModal();
            }}>Yes</button>
            <button className="alert-cancel" onClick={() => {
              this.setState({ editAeTrackId: null })
              this.closeAeTrackComfirmModal();

            }}>No</button>
            {isLoading ? <div className="loader loader-infra" /> : null}
          </div>
        </div>
      </Modal>
    )
  }

  render() {
    const { aeTrack, aeRequiredAttributes } = this.state;
    const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
    const { isDesignDir, isTeamLeader } = this.props.permissionsModule;

    var lastItem = aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1];
    var dateToday = this.getCurrentDate();

    return (
      <div>

        <div className="row-wide ae-tracking">
          <div className="col s12">
            <h4 className="bar-bottom">A&E Tracking</h4>
          </div>

          {this.state.showSavedMsg &&
            <ToastContainer
              hideProgressBar={true}
              newestOnTop={true}
              autoClose={2000}
              position={'top-center'}
            />}

          {this.state.showWarningMsg &&
            <ToastContainer
              hideProgressBar={true}
              newestOnTop={true}
              autoClose={2000}
              position={'top-center'}
            />}

          {this.state.showEmailSuccess &&
            <ToastContainer
              hideProgressBar={true}
              newestOnTop={true}
              autoClose={2000}
              position={'top-center'}
            />}

          {this.state.showEmailError &&
            <ToastContainer
              hideProgressBar={true}
              newestOnTop={true}
              autoClose={2000}
              position={'top-center'}
            />}

          <div>

            {aeTrack &&
              <div>
                {isDesignDir
                  ? <div>
                    <div className="col s12 m6 l4">
                      <div className="boxed">

                        <div className="controls">
                          <label>Bluebeam Project Id</label>
                          <input type="text" name="bluebeamProjectId" value={aeTrack.bluebeamProjectId} maxLength="50"
                            onChange={this.handleChangeInput('bluebeamProjectId')} />
                        </div>

                        <div className={'controls required with-select ' + aeRequiredAttributes['jobTypeId']}>
                          <label>Job Type</label>
                          <Select name=''
                            value={aeTrack.jobTypeId}
                            options={this.getSelectOptions('jobTypes_AE', 'jobType')}
                            onChange={this.handleSelectChange('jobTypeId')}
                          />
                        </div>

                        <div className="controls required date-control" id={aeRequiredAttributes['strategyBoardDate']}>
                          <label>Strategy Board Date</label>
                          <DateField name="strategyBoardDate"
                            value={aeTrack.strategyBoardDate}
                            limits={{}}
                            onChange={this.handleDateChange('strategyBoardDate')}
                          />
                        </div>

                        <div className="controls date-control">
                          <label>Field Visit Date</label>
                          <DateFieldFixedDateBelow name="fieldVisitDate"
                            value={aeTrack.fieldVisitDate}
                            limits={{ dateBelow: dateToday }}
                            onChange={this.handleDateChange('fieldVisitDate')}
                          />
                        </div>

                        <div className="controls-padding">
                          <label className="label-radio">Pre-Schematic phase exists:</label>
                          <div>
                            <div className="md-radio md-radio-inline">
                              <input id="3" type="radio" checked={aeTrack.isPreSchematic} onChange={this.handleCheckboxChange('isPreSchematic')} />
                              <label htmlFor="3">Yes</label>
                            </div>
                            <div className="md-radio md-radio-inline">
                              <input id="4" type="radio" checked={!aeTrack.isPreSchematic} onChange={this.handleCheckboxChange('isPreSchematic')} />
                              <label htmlFor="4">No</label>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className='col s12 m6 l6 padding-left-0 padding-right-0' id='unsetScrollX'>
                            <div className={'controls required with-select ' + aeRequiredAttributes['disciplineId']}>
                              <label>Discipline</label>
                              <Select name=''
                                value={aeTrack.disciplineId}
                                options={this.getSelectOptions('disciplines_AE', 'discipline')}
                                onChange={this.handleSelectChange('disciplineId')}
                              />
                            </div>
                          </div>

                          <div className='col s12 m6 l6 padding-left-0 padding-right-0' id='unsetScrollX'>
                            <div className={'controls required with-select ' + aeRequiredAttributes['designSourceId']}>
                              <label>Design Source</label>
                              <Select name=''
                                value={aeTrack.designSourceId}
                                options={this.getSelectOptions('designSources_AE', 'designSource')}
                                onChange={this.handleSelectChange('designSourceId')}
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div className="col s12 m6 l4">
                      <div className="boxed">

                        <div className={'controls required with-select ' + aeRequiredAttributes['trackId']}>
                          <label>Track</label>
                          <Select name=''
                            value={aeTrack.trackId}
                            options={this.getSelectOptions('tracks_AE', 'track')}
                            onChange={this.handleSelectChange('trackId')} />
                        </div>

                        <div className="row">
                          <div className="col s6">
                            <div className="padding-top-bottom-2">
                              <span> {aeTrack.sustDes ? <MdDone size={18} color="#008000" /> : <MdClose size={18} color="#F4633D" />}</span> Sust Des
                            </div>
                          </div>

                          <div className="col s6">
                            <div className="row inner-box-content" id="innerContentCustomPadding">
                              <div className="md-checkbox">
                                <input id="histPres"
                                  type="checkbox"
                                  onChange={this.handleCheckboxChange('histPres')}
                                  checked={aeTrack.histPres} />
                                <label htmlFor="histPres">Hist Pres</label><span></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <TeamMemberSearchAE onAdd={this.addMember}
                          team={this.props.trackingMembers_AE}
                          permissionsModule={this.props.permissionsModule}
                          leaderOrMember={aeRequiredAttributes['leaderOrMember']} />

                        {this.renderModal()}

                      </div>
                    </div>
                  </div>

                  : <AETrackingViewOnly aeTrack={aeTrack}
                    permissionsModule={this.props.permissionsModule}
                    projectId={this.props.projectId}
                    jobTypes_AE={this.props.jobTypes_AE}
                    disciplines_AE={this.props.disciplines_AE}
                    designSources_AE={this.props.designSources_AE}
                    tracks_AE={this.props.tracks_AE}
                    handleCheckboxChange={this.handleCheckboxChange}
                    trackingMembers={this.props.trackingMembers_AE}
                    toEdit={this.state.toEdit}
                    addMember={this.addMember}
                    renderModal={this.renderModal} />}

                <div className="col s12 m12 l4">
                  <div className="boxed">
                    <div className="controls">
                      <label>Count Down</label>
                      <span>{aeTrackBottomPartArray.length > 0 && aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1].aeTargetDate !== '' && aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1].aeTargetDate !== null
                        && this.calcDaysRemaining(aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1])}</span>
                    </div>

                    <div className="controls">
                      <label>Current Phase</label>
                      <span>{this.getPhaseName(aeTrack)}</span>
                    </div>

                    <div className="controls">
                      <label>Next Milestone</label>
                      <span>{this.getNextPhaseName(aeTrack)}</span>
                    </div>

                    <div className="controls">
                      <label>Request Status</label>
                      <span>{this.getStatusTracking(aeTrack.statusTrackingId)}</span>
                    </div>
                    
                    <div className="controls">
                      <label>Queue Type</label>
                      <span>{this.getQueueName(aeTrack.queueTypeId)}</span>
                    </div>

                    <div className="controls">
                      <label>Comment</label>
                      <span>{aeTrack.comment}</span>
                    </div>
                  </div>
                </div>

                {this.renderConfirmModal()}

                {isDesignDir &&
                  <div className="row">
                    <div className="col s12">
                      <button className="btn-save margin-bottom-075 margin-left-0" onClick={this.validateAEtop}
                      >Save</button>
                    </div>
                  </div>}

                <a className='downloadDocRfs' ref={link => this.downloadLink = link}>Download</a>

              </div>}

            <div className="row">
              <div className="col s12"><h4 className="bar-bottom">Design Team members</h4></div>
              {this.props.trackingMembers_AE.length > 0
                ? this.renderTable()
                : <div className="col s12">
                  <div>This project has no design team members yet.</div>
                </div>}
            </div>

            {aeTrackBottomPartArray.length > 0 &&
              <div>

                {this.renderConfirmModalPhase()}

                {this.renderCommentsModal()}

                {this.renderConfirmModalComment()}
                {this.renderConfirmModalAETrack()}
                <div className="row">
                  <div className="col s12">
                    <h4 className="bar-bottom margin-top-15">Details</h4>
                  </div>

                  <div className="col s12 rf-table-scroll">
                    <div className="table">
                      <table className="td-table-border th-table-border table-striped">
                        <thead>
                          <tr>
                            <th colSpan="3" className="text-center">PM Queue</th>
                            <th colSpan="10" className="text-center">A&E Queue</th>
                          </tr>
                          <tr>
                            <th>Phase</th>
                            <th>PM Target Date</th>
                            <th>Date submitted by PM</th>
                            {/* <th>Documents</th>  */}
                            <th>A&E - Intake</th>
                            <th>A&E Accepted Date</th>
                            <th>A&E Rejected Date</th>
                            <th>A&E Target Date</th>
                            <th>Actual Duration/Target Days for Review</th>
                            <th>A&E Actual Reviewed Date</th>
                            <th className="padding-review-status">Review Status</th>
                            <th>Comments</th>
                            <th>Bluebeam Session Id</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {aeTrackBottomPartArray.map((row, index) =>
                            <tr key={row.id}>
                              <td>{row.lkp_Phase_AE?.phaseName}</td>

                              <td>{row.targetDate === null && row.pmSubmittedActualDate !== null
                                ? 'N/A'
                                : row.targetDate === null && row.pmSubmittedActualDate === null
                                  ? null
                                  : getDateValue(row.targetDate)}</td>

                              <td>{getDateValue(row.pmSubmittedActualDate)}</td>

                              <td>
                                {this.canEditAcceptedRejected(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader)
                                  ? <div>
                                    <div className="md-radio radio-grid-ae">
                                      <input id="5" type="radio" value="true" checked={row.intakeAccepted === true} onChange={this.handleIntakeChange('intakeAccepted', index)} />
                                      <label htmlFor="5">Accepted</label>
                                    </div>
                                    <div className="md-radio radio-grid-ae">
                                      <input id="6" type="radio" value="false" checked={row.intakeAccepted === false} onChange={this.handleIntakeChange('intakeAccepted', index)} />
                                      <label htmlFor="6">Rejected</label>
                                    </div>
                                  </div>
                                  : <span>{row.intakeAccepted === true && row.aeAcceptedDate
                                    ? 'Accepted'
                                    : row.intakeAccepted === false && row.aeRejectedDate
                                      ? 'Rejected'
                                      : ''}</span>}
                              </td>

                              <td className={'max-width-6 fixed-datePicker ' + (this.isAeAcceptedDateMissing(row) ? 'highlighted-orange' : '')}>

                                {this.canEditAeAcceptedDate(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader)
                                  ? <DateFieldFixedDateBelow
                                    name='aeAcceptedDate'
                                    disableManualEntry={true}
                                    value={row.aeAcceptedDate}
                                    limits={{ dateAbove: row.pmSubmittedActualDate, dateBelow: dateToday }}
                                    onChange={this.handleDateChangeBottom('aeAcceptedDate', index)}
                                  />
                                  : (!row.intakeAccepted) && (!row.intakeDisabled)
                                    ? null
                                    : row.intakeDisabled
                                      ? getDateValue(row.aeAcceptedDate)
                                      : null}
                              </td>

                              <td className={'max-width-6 fixed-datePicker ' + (this.isAeRejectedDateMissing(row) ? 'highlighted-orange' : '')}>
                                {this.canEditAeRejectedDate(row, aeTrack, aeTrackBottomPartArray, lastItem, isDesignDir, isTeamLeader)
                                  ? <DateField
                                    name='aeRejectedDate'
                                    value={row.aeRejectedDate}
                                    limits={{}}
                                    onChange={this.handleDateChangeBottom('aeRejectedDate', index)}
                                  />
                                  : (row.intakeAccepted)
                                    ? null
                                    : getDateValue(row.aeRejectedDate)}
                              </td>

                              <td>{(row.aeAcceptedDate)
                                && getDateValue(row.aeTargetDate)}</td>

                              <td>{(row.aeAcceptedDate)
                                ? <span>{this.calcDaysRemaining(row)} / 21</span>
                                : null}</td>

                              <td className={'max-width-6 fixed-datePicker ' + (this.isAeReviewDateMissing(row) ? 'highlighted-orange' : '')}>
                                {this.canEditActualReviewDate(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader)
                                  ? <DateFieldFixedDateBelow name='aeActualReviewedDate'
                                    value={row.aeActualReviewedDate}
                                    limits={{ dateAbove: row['aeAcceptedDate'], dateBelow: dateToday }}
                                    onChange={this.handleDateChangeBottom('aeActualReviewedDate', index)}
                                  />
                                  : row.intakeAccepted === false
                                    ? null
                                    : getDateValue(row.aeActualReviewedDate)}
                              </td>

                              <td className={'max-width-6 fixed-selectDd ' + (this.isReviewStatusMissing(row) ? 'highlighted-orange-select' : '')}>
                                { this.canEditStatus(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader)
                                  ? <div className="controls with-select select-inside-table">
                                    <Select name=''
                                      value={row.reviewStatusId}
                                      options={this.getSelectOptionsReviewStatus('reviewStatuses_AE', 'reviewStatus')}
                                      menuPlacement="auto"
                                      minMenuHeight={150}
                                      maxMenuHeight='none'
                                      onChange={this.handleSelectChangeReviewStatus('reviewStatusId', index, row.reviewStatusId)} />
                                  </div>
                                  : row.intakeAccepted === false
                                    ? null
                                    : <span>{row.reviewStatusId ? this.getReviewStatusName(row.reviewStatusId) : null}
                                    </span>}
                              </td>

                              <td className='max-width-200'>
                                { this.canEditComment(row, aeTrack, aeTrackBottomPartArray, lastItem, isDesignDir, isTeamLeader)
                                  ? <textarea id="textarea-custom-bordered" rows="3" maxLength="1500"
                                    name="comments" value={row.comments} onChange={this.handleChange('comments', index)}
                                    className={this.isCommentMissing(row) ? 'highlighted-orange-textarea' : ''}>
                                  </textarea>
                                  : (<div style={{ position: 'relative' }} onClick={() => this.showCommentsModal(row)}>
                                    {this.canModifyComment(isDesignDir, aeTrackBottomPartArray, lastItem, row, aeTrack) &&
                                     <span className="comment-edit-button"><MdCreate size={22} /></span>}
                                    <p className='ellipsis' >{row.comments}</p>
                                  </div>)}
                              </td>

                              <td>
                                {this.canEditBluebeam(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader)
                                  ? <input type="text" name="bluebeamSessionId" value={row.bluebeamSessionId} maxLength="50"
                                    onChange={this.handleChange('bluebeamSessionId', index)} />
                                  : <span>{row.bluebeamSessionId}</span>}
                              </td>

                              <td>
                                {/* && aeTrack.queueTypeId === 2  */}
                                {this.canEditPrevRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) && 
                                <button className="btn-save margin-left-0 margin-top-075" onClick={() => this.showAETrackEditComfirmationModal(row.id)}>
                                  Edit
                                </button>
                                }
                                {this.canEditCurrentRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) && 
                                <button className="btn-save margin-left-0 margin-top-075" onClick={() => this.showAETrackEditComfirmationModal(row.id)}>
                                  Edit
                                </button>
                                }
                                {this.canSavePrevRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) && 
                                <button className="btn-save margin-left-0 margin-top-075" onClick={() => {
                                  this.putTrackingPhase(aeTrackBottomPartArray[aeTrackBottomPartArray.length - 2]);
                                }}>
                                  Save
                                </button>
                                }

                                {this.canSaveCurrentRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) && 
                                <button className="btn-save margin-left-0 margin-top-075" onClick={() => {
                                  this.putTrackingPhase(aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1]);
                                }}>
                                  Save
                                </button>
                                }
                                {this.canSaveLastRecord(aeTrack, lastItem, row, isDesignDir, isTeamLeader)
                                  ? <button className="btn-save margin-left-0 margin-top-075" onClick={this.confirmSubmitPhase} disabled= {this.isSaveButtonDisabled(row)}>
                                    Save
                                  </button>
                                  : null}
                              </td>

                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            }
          </div>
        </div>
      </div>
    );
  }



  isSaveButtonDisabled(row) {
    return ((this.state.copyAeTrack?.intakeAccepted == null || row.intakeAccepted == false) && (row.aeRejectedDate == null || row.comments == null || row.comments == '')) &&
      ((this.state.copyAeTrack?.intakeAccepted == null || row.intakeAccepted == true) && (row.aeAcceptedDate == null || row.aeAcceptedDate == '')) ||
      ((this.state.copyAeTrack?.intakeAccepted != null) && (row.aeActualReviewedDate == null || row.reviewStatusId == null || (row.comments == null || row.comments == '')));
  }

  canSaveLastRecord(aeTrack, lastItem, row, isDesignDir, isTeamLeader) {
    return aeTrack && ((lastItem.id === row.id) && aeTrack.queueTypeId === 2 && (isDesignDir || isTeamLeader)) && aeTrack?.statusTrackingId !== 3;
  }

  canSaveCurrentRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) {
    return ((aeTrackBottomPartArray.length - 1) === aeTrackBottomPartArray.findIndex(e => e.id == row.id)) && this.state.editAeTrackId != null && isDesignDir && (aeTrack?.statusTrackingId == 3 && aeTrack.currentPhaseId == null);
  }
  canSavePrevRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) {
    return ((aeTrackBottomPartArray.length - 2) === aeTrackBottomPartArray.findIndex(e => e.id == row.id)) && this.state.editAeTrackId != null && isDesignDir && (aeTrack?.statusTrackingId != 3 && aeTrack.currentPhaseId != null);
  }

  canEditCurrentRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) {
    return ((aeTrackBottomPartArray.length - 1) === aeTrackBottomPartArray.findIndex(e => e.id == row.id) && row.intakeAccepted) && isDesignDir && (aeTrack?.statusTrackingId == 3 && aeTrack.currentPhaseId == null);
  }

  canEditPrevRecord(aeTrackBottomPartArray, row, isDesignDir, aeTrack) {
    return ((aeTrackBottomPartArray.length - 2) === aeTrackBottomPartArray.findIndex(e => e.id == row.id) && row.intakeAccepted) && isDesignDir && (aeTrack?.statusTrackingId != 3 && aeTrack.currentPhaseId != null);
  }

  isCommentMissing(row) {
      return (!row.intakeAccepted && (row.comments === null || row.comments === '')) || 
      (row.intakeAccepted && (row.reviewStatusId === 2 || row.reviewStatusId === 3 || row.reviewStatusId === 4));
  }
  
  isAeAcceptedDateMissing(row) {
    return row.aeAcceptedDate === '' || row.aeAcceptedDate === null;
  }

  isAeRejectedDateMissing(row) {
    return row.aeRejectedDate === '' || row.aeRejectedDate === null;
  }

  isAeReviewDateMissing(row) {
    return (row.reviewStatusId !== '' && row.reviewStatusId !== null) && (row.aeActualReviewedDate === null || row.aeActualReviewedDate === '');
  }

  isReviewStatusMissing(row) {
    return this.state.isAccepted && ((row.reviewStatusId === '' || row.reviewStatusId === null) && (row.aeActualReviewedDate !== null && row.aeActualReviewedDate !== ''));
  }

  isAeTrack(aeTrack) {
    return aeTrack && (aeTrack.queueTypeId === 2);
  }

  isLastRow(aeTrackBottomPartArray, lastItem, row) {
    return aeTrackBottomPartArray.length === 1 || lastItem.id === row.id;
  }

  isManager(isDesignDir, isTeamLeader) {
    return isDesignDir || isTeamLeader;
  }

  canEditAcceptedRejected(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader) {
    return aeTrack && 
      this.isLastRow(aeTrackBottomPartArray, lastItem, row) && 
      this.isAeTrack(aeTrack) &&
      this.isManager(isDesignDir, isTeamLeader) && 
      !row.intakeDisabled && 
      aeTrack?.statusTrackingId !== 3;
  }

  canEditAeAcceptedDate(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader) {
    return aeTrack && 
      this.isLastRow(aeTrackBottomPartArray, lastItem, row) && 
      this.isAeTrack(aeTrack) &&
      this.isManager(isDesignDir, isTeamLeader) && 
      (row.intakeAccepted) && 
      (!row.intakeDisabled) && 
      aeTrack?.statusTrackingId !== 3;
  }

  canEditAeRejectedDate(row, aeTrack, aeTrackBottomPartArray, lastItem, isDesignDir, isTeamLeader) {
    return (row.intakeAccepted != null) && 
      aeTrack && 
      this.isLastRow(aeTrackBottomPartArray, lastItem, row) && 
      this.isManager(isDesignDir, isTeamLeader) && 
      (!row.intakeAccepted) && 
      aeTrack?.statusTrackingId !== 3;
  }

  canEditActualReviewDate(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader) {
    return (this.state.copyAeTrack?.intakeAccepted) && 
      aeTrack && 
      this.isLastRow(aeTrackBottomPartArray, lastItem, row) && 
      this.isAeTrack(aeTrack) &&
      this.isManager(isDesignDir, isTeamLeader) && 
      (row.intakeAccepted) && 
      aeTrack?.statusTrackingId !== 3 || 
      
      (this.state.canEditAETrack || (this.state.editAeTrackId === row.id));
  }

  canEditStatus(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader) {
    return (this.state.copyAeTrack?.intakeAccepted) && 
      aeTrack && 
      this.isLastRow(aeTrackBottomPartArray, lastItem, row) && 
      this.isAeTrack(aeTrack) &&
      this.isManager(isDesignDir, isTeamLeader) && 
      (row.intakeAccepted) && 
      aeTrack?.statusTrackingId !== 3 || 
      
      (this.state.canEditAETrack || (this.state.editAeTrackId === row.id));
  }

  canEditComment(row, aeTrack, aeTrackBottomPartArray, lastItem, isDesignDir, isTeamLeader) {
    return (this.state.copyAeTrack?.intakeAccepted || row.aeRejectedDate) &&
      ( aeTrack &&
        this.isLastRow(aeTrackBottomPartArray, lastItem, row) &&
        this.isAeTrack(aeTrack) &&
        this.isManager(isDesignDir, isTeamLeader) &&
        aeTrack?.statusTrackingId !== 3
        ||

        (this.state.canEditAETrack || (this.state.editAeTrackId === row.id))
      );
  }
  
  canEditBluebeam(aeTrack, aeTrackBottomPartArray, lastItem, row, isDesignDir, isTeamLeader) {
    return (this.state.copyAeTrack?.intakeAccepted) && 
      aeTrack && 
      this.isLastRow(aeTrackBottomPartArray, lastItem, row) && 
      this.isAeTrack(aeTrack) &&
      this.isManager(isDesignDir, isTeamLeader) && 
      aeTrack?.statusTrackingId !== 3;
  }

  // Can user modify an existing comment?
  // (Design Director can modify any comment, Team Leader can modify only the last row's comment)  
  canModifyComment(isDesignDir, aeTrackBottomPartArray, lastItem, row, aeTrack) {
    const result =  isDesignDir &&
      (!this.isLastRow(aeTrackBottomPartArray, lastItem, row));
    return result;
  }
}

AETracking.propTypes = {
  projectId: PropTypes.string.isRequired,
  permissionsModule: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    aeTracksMain: state.additionalProjectsStore.aeTracksMain,
    designSources_AE: state.additionalProjectsStore.designSources_AE,
    disciplines_AE: state.additionalProjectsStore.disciplines_AE,
    jobTypes_AE: state.additionalProjectsStore.jobTypes_AE,
    tracks_AE: state.additionalProjectsStore.tracks_AE,
    reviewStatuses_AE: state.additionalProjectsStore.reviewStatuses_AE,
    trackingMembers_AE: state.additionalProjectsStore.trackingMembers_AE,
    trackingPhases_AE: state.additionalProjectsStore.trackingPhases_AE,
    phases_AE: state.additionalProjectsStore.phases_AE,
    permissionsModule: state.projectsStore.permissionsModule,
    statusTracking_AE: state.additionalProjectsStore.statusTracking_AE,
    reviewPhaseStatuses_AE: state.additionalProjectsStore.reviewPhaseStatuses_AE,
  }
}

export default connect(mapStateToProps, {
  fetch_lkp_DesignSource_AE, fetch_lkp_Discipline_AE, fetch_lkp_JobType_AE, fetch_lkp_Track_AE,
  fetch_lkp_ReviewStatus_AE, fetchTrackingMembers_AE, getAETrackingByProjectId,
  fetchTrackingPhase_AE, fetch_lkp_Phase_AE, fetchPermissionsByModule, fetch_lkp_StatusTracking_AE, fetch_lkp_ReviewPhaseStatus_AE
})(AETracking);